import styled from 'styled-components';

export const SelectionSection = styled.div`
  padding: 12px;
  background: #f8f9fa;
  border: 1px dashed #dee2e6;
  border-radius: 6px;
`;

export const SelectedList = styled.div`
  .ant-list-item {
    background: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 8px;
    transition: all 0.2s ease;

    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      border-color: #1890ff;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  .ant-list-item-meta-title {
    margin-bottom: 4px;
  }

  .ant-list-item-action {
    margin-left: 16px;
  }
`;

export const SummarySection = styled.div`
  padding: 12px;
  background: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;

  .ant-typography {
    margin-bottom: 0;
  }
`;
